import { styled, css } from 'styled-components';
import { dontForwardProps, pxToRem } from '../../util';
import { colors } from '../../abstracts/colors';
const typeMap = {
  bold: {
    light: {
      color: 'var(--aui-on-neutral-soft)',
      backgroundColor: 'var(--aui-neutral-soft)'
    },
    gray: {
      color: colors.white,
      backgroundColor: colors.neutralDeeper
    },
    dark: {
      color: 'var(--aui-inverse-on-surface)',
      backgroundColor: 'var(--aui-inverse-surface)'
    },
    error: {
      color: 'var(--aui-status-on-error)',
      backgroundColor: 'var(--aui-status-error)'
    },
    success: {
      color: 'var(--aui-status-on-success)',
      backgroundColor: 'var(--aui-status-success)'
    },
    warn: {
      color: 'var(--aui-status-on-warning)',
      backgroundColor: 'var(--aui-status-warning)'
    },
    red: {
      color: 'var(--aui-accent-on-red)',
      backgroundColor: 'var(--aui-status-error)'
    },
    orange: {
      color: 'var(--aui-accent-on-orange)',
      backgroundColor: 'var(--aui-accent-orange)'
    },
    yellow: {
      color: 'var(--aui-accent-on-tennis)',
      backgroundColor: 'var(--aui-accent-tennis)'
    },
    green: {
      color: 'var(--aui-accent-on-green)',
      backgroundColor: 'var(--aui-accent-green)'
    },
    teal: {
      color: 'var(--aui-accent-on-teal)',
      backgroundColor: 'var(--aui-accent-teal)'
    },
    purple: {
      color: 'var(--aui-accent-on-purple)',
      backgroundColor: 'var(--aui-accent-purple)'
    },
    themeable: {
      color: 'var(--aui-tag-on-theme)',
      backgroundColor: 'var(--aui-tag-theme)'
    },
    update: {
      color: colors.black,
      backgroundColor: colors.brandTennis
    },
    attention: {
      color: colors.white,
      backgroundColor: colors.primaryDeep
    },
    disabled: {
      color: colors.neutralBrighter,
      backgroundColor: colors.neutralDeep
    }
  },
  soft: {
    light: {
      color: 'var(--aui-on-neutral)',
      backgroundColor: 'var(--aui-neutral)'
    },
    gray: {
      color: colors.neutralDeeper,
      backgroundColor: colors.neutralBrightest
    },
    dark: {
      color: 'var(--aui-on-neutral-soft)',
      backgroundColor: 'var(--aui-neutral-soft)'
    },
    error: {
      color: 'var(--aui-status-on-error-soft)',
      backgroundColor: 'var(--aui-status-error-soft)'
    },
    success: {
      color: 'var(--aui-status-on-success-soft)',
      backgroundColor: 'var(--aui-status-success-soft)'
    },
    warn: {
      color: 'var(--aui-status-on-warning-soft)',
      backgroundColor: 'var(--aui-status-warning-soft)'
    },
    red: {
      color: 'var(--aui-accent-on-red-soft)',
      backgroundColor: 'var(--aui-accent-red-soft)'
    },
    orange: {
      color: 'var(--aui-accent-on-orange-soft)',
      backgroundColor: 'var(--aui-accent-orange-soft)'
    },
    yellow: {
      color: 'var(--aui-accent-on-tennis-soft)',
      backgroundColor: 'var(--aui-accent-tennis-soft)'
    },
    green: {
      color: 'var(--aui-accent-on-green-soft)',
      backgroundColor: 'var(--aui-accent-green-soft)'
    },
    teal: {
      color: 'var(--aui-accent-on-teal-soft)',
      backgroundColor: 'var(--aui-accent-teal-soft)'
    },
    purple: {
      color: 'var(--aui-accent-on-purple-soft)',
      backgroundColor: 'var(--aui-accent-purple-soft)'
    },
    themeable: {
      color: 'var(--aui-tag-on-theme-alt)',
      backgroundColor: 'var(--aui-tag-theme-alt)'
    },
    update: {
      color: colors.black,
      backgroundColor: colors.brandTennis
    },
    attention: {
      color: colors.white,
      backgroundColor: colors.primaryDeep
    },
    disabled: {
      color: colors.neutralBrighter,
      backgroundColor: colors.neutralDeep
    }
  }
};
export const TextWrapper = styled.span.withConfig({
  componentId: "aui__sc-21j45i-0"
})(["display:inline-block;overflow:hidden;text-overflow:ellipsis;padding:2px 0;margin:-2px 0;"]);
const sizeMap = {
  small: css(["font-size:0.75rem;padding:var(--aui-spacing-025);"]),
  regular: css(["font-size:0.875rem;padding:", "rem var(--aui-spacing-050);"], pxToRem(3)),
  large: css(["font-size:1rem;padding:var(--aui-spacing-050) var(--aui-spacing-100);"])
};
export const StyledTag = styled.span.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-21j45i-1"
})(["display:flex;align-content:center;justify-content:center;color:", ";border:0;border-radius:", ";background-color:", ";box-sizing:border-box;line-height:1;width:fit-content;", " ", ""], ({
  type,
  family
}) => typeMap[family][type].color, ({
  size
}) => size === 'small' ? 'var(--aui-border-radius-025)' : 'var(--aui-border-radius-050)', ({
  type,
  family
}) => typeMap[family][type].backgroundColor, ({
  truncateText
}) => truncateText && css(["max-width:100%;", "{text-wrap:nowrap;}"], TextWrapper), ({
  size
}) => sizeMap[size] ?? sizeMap['small']);
export const TagIconWrapper = styled.span.withConfig({
  componentId: "aui__sc-21j45i-2"
})(["", " margin-right:", ";flex-shrink:0;display:inline-flex;align-items:center;span{display:block;}"], ({
  $size
}) => $size === 'large' && `margin-left: -0.25rem;`, ({
  $size
}) => $size === 'large' ? '0.25rem' : '0.125rem');